import type { AttachmentKind } from '../types/chat.types'

export const MAX_ATTACHMENTS_PER_MESSAGE = 30
export const MAX_ATTACHMENT_FILE_SIZE = 40 * 1024 * 1024

/** Maximum number of attachment uploads in flight at once. */
export const MAX_CONCURRENT_UPLOADS = 6

/** Returns the per-file attachment size limit for user-facing messages. */
export function formatAttachmentSizeLimit(): string {
  return `${Math.round(MAX_ATTACHMENT_FILE_SIZE / (1024 * 1024))}MB`
}

export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.docx',
  '.xlsx',
  '.pdf',
] as const

export const ALLOWED_ATTACHMENT_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
] as const

export function getAttachmentKind(contentType: string, filename: string): AttachmentKind {
  const type = contentType.toLowerCase()
  const extension = filename.split('.').pop()?.toLowerCase() || ''

  if (type.startsWith('image/')) return 'image'
  if (['pdf', 'doc', 'docx'].includes(extension)) return 'document'
  if (['xls', 'xlsx', 'csv'].includes(extension)) return 'spreadsheet'
  if (['txt', 'md', 'html'].includes(extension)) return 'text'

  return 'other'
}

export function isAllowedAttachment(file: File): boolean {
  if (file.type && file.type !== 'application/octet-stream') {
    const mimeType = file.type.toLowerCase()
    if ((ALLOWED_ATTACHMENT_MIME_TYPES as readonly string[]).includes(mimeType)) {
      return true
    }
  }

  const extension = ('.' + (file.name.split('.').pop() || '')).toLowerCase()
  return (ALLOWED_ATTACHMENT_EXTENSIONS as readonly string[]).includes(extension)
}

export function getAcceptString(): string {
  return ALLOWED_ATTACHMENT_EXTENSIONS.join(',')
}

